<span *ngIf="data === 0 || data"
	>{{ dataType === 'double' ? (data | number: precisionString) : data }} {{ suffix }}</span
>
